import React, { useContext, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Checkbox, DropdownItem, Header, Popup } from 'semantic-ui-react';

import {
    ControlledPopup,
    DateTimeUtils,
    EllipsisDropdown,
    Notification,
    OnHoverOnClick,
    Person,
    STATUS_TYPES,
    Table,
} from 'dyl-components';

import HoverContent from 'shared/hoverContent';
import Contact from 'shared/Contact';
import { ArchivedRecordsContext } from 'shared/context/ArchivedRecordsProvider';
import { useDispatch, useSelector } from 'react-redux';
import archiveActions from 'actions/archive';

export const ArchivedReportsRow = ({
    report,
    setIsModalOpen,
    totalRecordsCount,
    cancelFunction
}) => {
    const { setIsArchivedView } = useContext(ArchivedRecordsContext);
    const [open, setOpen] = useState(false)
    const contact = {
        ...report,
        contact_name: report?.name,
    };

    const openViewModal = () => {
        setIsArchivedView(true);
        setIsModalOpen({
            open: true,
            contact_id: report?.contact_type === "person" ? report?.contact_id : null,
            account_id: report?.contact_type !== "person" ? report?.contact_id : null,
        });
    };
    const dispatch = useDispatch()
    const [params] = useSearchParams()
    const productPermissions = useSelector(
        (state) => state.subscription.productPermissions
    );
    const total_records_limit = productPermissions?.unique?.records;
    return (
        <Table.Row>
            <Table.Cell>
                <Checkbox disabled />
            </Table.Cell>

            <Table.Cell>
                {report.archived_at && (
                    <>
                        <div>
                            <b>
                                {DateTimeUtils.formatEpoch(
                                    report.archived_at,
                                    DateTimeUtils.WORD_DATE_FORMAT
                                )}
                            </b>
                        </div>

                        <div>
                            {DateTimeUtils.formatEpoch(
                                report.archived_at,
                                DateTimeUtils.TIME_FORMAT
                            )}
                        </div>
                    </>
                )}
            </Table.Cell>

            <Table.Cell>
                <Contact
                    contact={{ ...contact, id: report?.contact_id, archived: true }}
                    name={report?.name}
                    linkToContact={
                        <Link to={`/contact/${report?.contact_id}`}>
                            {report?.name}
                        </Link>
                    }
                    displayIcon
                    account={report?.contact_type}
                />
            </Table.Cell>

            <Table.Cell>
                <OnHoverOnClick
                    clickable={false}
                    hoverContent={
                        <HoverContent user={report?.archived_by} />
                    }
                    trigger={
                        report?.archived_by ? (
                            <div className='TableTruncateFixedWidth'>
                                <Person
                                    username={`${report?.archived_by.first_name} ${report?.archived_by.last_name}`}
                                    email={report?.archived_by.email}
                                    isInactiveUser={!report?.archived_by.active}
                                    popup={false}
                                    title=' '
                                />
                            </div>
                        ) : undefined
                    }
                />
            </Table.Cell>

            <Table.Cell>
                <EllipsisDropdown toggleEllipsisDropdown={() => { setOpen(open => !open) }} isDropdownOpen={open}>
                    <DropdownItem
                        text='View'
                        icon='eye'
                        onClick={openViewModal}
                    />

                    {total_records_limit < (totalRecordsCount + 1) ? <Popup
                        content="Records Limit Reached."
                        trigger={<DropdownItem
                            text='Unarchive'
                            icon='archive'
                            disabled
                        />
                        }
                        open={open}
                        position='bottom center'
                        inverted
                    /> : <ControlledPopup
                        header={
                            <Header
                                as='h4'
                                textAlign='center'
                            >
                                Are you sure?
                            </Header>
                        }
                        trigger={
                            <DropdownItem
                                text='Unarchive'
                                icon='archive'
                                disabled={total_records_limit < (totalRecordsCount + 1)}
                            />
                        }
                        onConfirm={async () => {
                            if (total_records_limit >= (totalRecordsCount + 1)) {
                                await dispatch(archiveActions.unArchiveRecords(report?.contact_id))
                                Notification.alert(
                                    "Record successfully unarchived.",
                                    STATUS_TYPES.SUCCESS
                                );
                                dispatch(archiveActions.readArchivedReports({ ...params }))
                                cancelFunction();
                            }
                        }}
                        position='bottom center'
                    />}
                </EllipsisDropdown>
            </Table.Cell>
        </Table.Row>
    );
};